import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollView } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import { Button } from '@/components/ButtonComponent';
import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { useSelectionCount } from '@/feature/betslip-sbk/hooks/betslip-hooks';
import { useKeyboardHeight } from '@/hooks/use-keyboard-height';
import { common } from '@/styles/styles';
import { isAndroid } from '@/utils/constants-platform-specific';

import { RemovePicksButton } from '../RemovePicksButton';
import { CLEAR_BUTTON_HEIGHT, betSlipTabStyle } from '../SinglesList';
import { SoccerSettlementBanner } from '../SoccerSettlementBanner';
import { ACTION_TRAY_MAX_HEIGHT } from '../betslip-action-tray/BetSlipActionTray';
import { ParlayCard } from '../parlay-card/ParlayCard';

const BASE_BOTTOM_PADDING = ACTION_TRAY_MAX_HEIGHT + CLEAR_BUTTON_HEIGHT + 16;

export const ComboTabScreen = () => {
    const selectionCount = useSelectionCount();
    const { t } = useTranslation('betslip_sbk');
    const navigation = useNavigation();
    const keyboardHeight = useKeyboardHeight(isAndroid);

    const contentContainerStyle = useMemo(
        () => ({
            paddingBottom: isAndroid && keyboardHeight > 0 ? BASE_BOTTOM_PADDING + keyboardHeight : BASE_BOTTOM_PADDING,
        }),
        [keyboardHeight]
    );

    if (selectionCount <= 1) {
        return (
            <Box flex={1} justifyContent="center" alignItems="center" px="s20" gap="s20">
                <Box justifyContent="center" alignItems="center" gap="s4">
                    <Text variant="headlineMedium" color={ds.colorToken.text.primary}>
                        {t('no_parlays_available')}
                    </Text>
                    <Text color="neutral300" variant="bodyMedium">
                        {t('no_parlays_available_description')}
                    </Text>
                </Box>
                <Button label={t('add_picks')} hierarchy="primary" size="s" onPress={() => navigation.goBack()} />
            </Box>
        );
    }
    return (
        <ScrollView
            style={[betSlipTabStyle.root, common.paddingHorizontal]}
            contentContainerStyle={contentContainerStyle}
            keyboardShouldPersistTaps="handled"
            keyboardDismissMode="on-drag"
        >
            <SoccerSettlementBanner />
            <ParlayCard />
            <Box alignItems="center" mt="s24">
                <RemovePicksButton />
            </Box>
        </ScrollView>
    );
};
